import React,{useEffect,useState} from 'react'
import {motion} from 'framer-motion'
import './About.scss';
import {urlFor, integrate} from "../../integrate";
import { ApplicationWrap ,MotionWrap} from '../../wrapper';


const About = () => {
  const [about, setAbout] = useState([]);

  useEffect(() => {
        const query ='*[_type == "about"]';
        integrate.fetch(query)
        .then((data)=> setAbout(data));

  }, [])
  
  return (
    <>
    <h1 className="head-text">
      There are three <span>responses</span> to a piece of <span>design </span>- <br />
        <span>yes, no </span>and<span> wow!</span> <br />
        <span>wow</span> is the one to <span>aim</span> for.
    </h1>

    <div className="app__profiles">
        {about.map((item,i)=> (
          <motion.div
               whileInView={{opacity:1}}
               whileHover={{scale:1.1}}
               transition={{duration: 0.5, type: 'tween'}}
               className="app__profile-item"
               key={item.title + i}
          >
        <img src={urlFor(item.imageurl)} alt={item.title} />
        <h2 className='bold-text' style={{marginTop: 20}}>{item.title}</h2>
        <h2 className='p-text' style={{marginTop: 10}}>{item.description}</h2>

          </motion.div>
        ))}
    </div>
    </>
  )
}

export default ApplicationWrap(
  MotionWrap(About, 'app__about'),
  'about',
  'app__whitebg',
);